import { erpAxios } from '..';

const statusUToku = async (data) => {
  return await erpAxios.post(`/statusZahtjeva/u-toku`, data);
};

export default statusUToku;
